module.exports = __webpack_public_path__ + "img/base_nature_grotte.73722971.svg";